import * as actions from './dmvActions';
import { mapMilitaryStatusCodeToInternalValue } from '../../../lib/data';

const initialState = {
  selected: '',
  appProfile: '',
  lookup: '',
  commercial: '',
  countyCode: '',
  fromDeepLink: false,
};

const dmvReducers = {
  [actions.DMV_DMVRR_CLEAR_DATA]: () => initialState,
  [actions.DMV_SET_FROM_DEEP_LINK]: (state, { payload }) => ({
    ...state,
    fromDeepLink: payload,
  }),
  [actions.DMV_RENEW_LICENSE]: (state, { payload }) => {
    return { ...state, ...{ selected: payload } };
  },
  [actions.DMV_STORE_SELECTED_VEHICLE]: (state, { payload }) => {
    return { ...state, ...{ selected: payload } };
  },
  [actions.DMV_STORE_APP_PROFILE]: (state, { payload }) => {
    return {
      ...state,
      appProfile: {
        ...payload,
        militaryStatusCode: mapMilitaryStatusCodeToInternalValue(
          payload?.militaryStatusCode
        ),
      },
    };
  },
  [actions.DMV_STORE_LOOKUP]: (state, { payload }) => {
    return { ...state, ...{ lookup: payload } };
  },
  [actions.DMV_COMMERCIAL_VEHICLE]: (state, { payload }) => {
    return { ...state, ...{ commercial: payload } };
  },
  [actions.DMV_STORE_COUNTY_CODE]: (state, { payload }) => {
    return {
      ...state,
      ...{ countyCode: payload },
    };
  },
  [actions.DMV_STORE_RENEWAL_TERM]: (state, { payload }) => {
    return {
      ...state,
      ...{ renewalTerm: payload },
    };
  },
  [actions.DMV_STORE_APP_INSURANCE]: (state, { payload }) => {
    return {
      ...state,
      ...{
        appProfile: {
          ...state.appProfile,
          ...{ insuranceDetails: payload },
        },
      },
    };
  },
  [actions.DMV_UPDATE_ERNO]: (state, { payload }) => {
    return {
      ...state,
      ...{
        appProfile: {
          ...state.appProfile,
          ...{ ernoNoticeChoice: payload.ernoNoticeChoice },
        },
      },
    };
  },

  [actions.DMV_UPDATE_MILITARY_STATUS]: (state, { payload }) => {
    return {
      ...state,
      ...{
        appProfile: {
          ...state.appProfile,
          militaryStatusCode: payload.militaryStatus.value || undefined,
        },
      },
    };
  },

  [actions.DMV_UPDATE_IMC_NO]: (state, { payload }) => {
    return {
      ...state,
      ...{
        appProfile: {
          ...state.appProfile,
          ...{ imcNo: payload.imcNo },
        },
      },
    };
  },
  [actions.DMV_UPDATE_MAILING_ADDRESS]: (state, { payload }) => {
    return {
      ...state,
      ...{
        appProfile: {
          ...state.appProfile,
          ...{ mailingAddress: payload.mailingAddress },
        },
      },
    };
  },
  [actions.DMV_UPDATE_FEE_DETAILS]: (state, { payload }) => {
    return {
      ...state,
      ...{
        appProfile: {
          ...state.appProfile,
          ...{ countyCode: payload.countyCode },
          ...{ feeDetails: payload.feeDetails },
          ...{ renewalTerm: payload.renewalTerm },
        },
      },
    };
  },
  [actions.DMV_UPDATE_DONATION_DETAILS]: (state, { payload }) => {
    return {
      ...state,
      ...{
        appProfile: {
          ...state.appProfile,
          ...{ donationDetails: payload },
        },
      },
    };
  },
  [actions.DMV_UPDATE_VEHICLE_COLOR_DETAILS]: (state, { payload }) => {
    return {
      ...state,
      ...{
        appProfile: {
          ...state.appProfile,
          ...{ vehicle: payload },
        },
      },
    };
  },
  [actions.DMV_UPDATE_PAYMENT_WAS_MADE]: (state, { status }) => {
    return {
      ...state,
      ...{
        appProfile: {
          ...state.appProfile,
          ...{ paymentWasMade: status },
        },
      },
    };
  },
  [actions.DMV_IS_VEHICLE_CERTIFIED]: (state, { isVehicleCertified }) => {
    return {
      ...state,
      ...{
        appProfile: {
          ...state.appProfile,
          ...{ isVehicleCertified: isVehicleCertified },
        },
      },
    };
  },
  [actions.DMV_UPDATE_IS_OUT_OF_STATE]: (state, { isOutOfState }) => {
    return {
      ...state,
      ...{
        appProfile: {
          ...state.appProfile,
          ...{ isOutOfState: isOutOfState },
        },
      },
    };
  },
  [actions.DMV_STORE_EXEMPTION]: (state, { payload }) => {
    return {
      ...state,
      ...{
        appProfile: {
          ...state.appProfile,
          ...{ affidavitReason: payload },
        },
      },
    };
  },
};

export default {
  name: 'dmv',
  reducers: dmvReducers,
};
